import { AgResourceLanguage } from '../types';
import { commonContent as EnUsCommonContent } from '../en-us/commonContent';

export const commonContent: AgResourceLanguage['commonContent'] = {
  ...EnUsCommonContent,
  orderBodyContent: {
    nextOnlyLabel: 'Eenmalig',
    outOfStockLabel: 'Niet op Voorraad',
    quantityLabel: 'Aantal:',
    productHiddenLabel: 'Product',
    productsSubtitle: 'Producten',
    subscriptionTitle: 'Subscription',
    otpTitle: 'This order only'
  },
  referFriendCard: {
    title: 'Vrienden Aanraden',
    text: 'Ontvang €15 voor elke vriend die je aanraadt zodra ze hun eerste aankoop doen.'
  },
  slider: {
    empty: {
      title: 'Onze Abonnementen'
    },
    notEmpty: {
      title: 'De AG1 Winkel',
      description: 'Exclusief beschikbaar voor leden'
    },
    cardContent: {
      addToSubscription: 'Toevoegen aan Abonnement',
      addedToSubscription: 'Toegevoegd aan Abonnement',
      addToNextOrder: 'Toevoegen aan Volgende Bestelling',
      addedToNextOrder: 'Toegevoegd aan Volgende Bestelling',
      maxQuantityReached: 'Maximale hoeveelheid bereikt',
      agzOtpButton: 'for $99',
      agzDisclaimer: '† When bundled in a subscription with AG1. An AGZ only subscription is $79.'
    }
  },
  buttons: {
    subscribeAndSave: 'Abonneer & Bespaar',
    subscribe: 'Abonneren',
    delete: 'Verwijderen'
  },
  status: {
    fulfilled: 'Verwerkt',
    partial: 'Gedeeltelijk verwerkt',
    paid: 'Zending in verwerking',
    refunded: 'Terugbetaald',
    partially: 'Gedeeltelijk terugbetaald',
    unpaid: 'Onbetaald'
  },
  statusV2: {
    Unfulfilled: 'Voorbereiden',
    Fulfilled: 'Verzonden',
    'On hold': 'Voorbereiden'
  }
};
